// AUTO-GENERATED by tools/generate-parallel.mjs --world 17. Do not edit by hand.
// Regenerate with: node tools/generate-parallel.mjs --world 17
// W17 (Gale) — wind cells nudge tiles +1 in the wind direction.
// // Builds on W14 post-slide pipeline. d=3-8 band; 1-2 wind cells per board.
import type { LevelDef } from '@tessera/engine';

export const WORLD_17_GENERATED: LevelDef[] = [
  // d*=3  branching=15.64  D=0.064  tiles=11
  {
    id: 'w17-l01',
    world: 17,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    wind: [
      { coord: { q: -2, r: 1 }, direction: 'SE' },
    ],
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 2 },
    ],
  },
  // d*=4  branching=13.37  D=0.120  tiles=11
  {
    id: 'w17-l02',
    world: 17,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    wind: [
      { coord: { q: -1, r: 2 }, direction: 'SE' },
    ],
    tiles: [
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: 0, r: 3 }, color: 2 },
    ],
  },
  // d*=5  branching=15.36  D=0.275  tiles=11
  {
    id: 'w17-l03',
    world: 17,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    wind: [
      { coord: { q: 1, r: 1 }, direction: 'NW' },
    ],
    tiles: [
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 2 },
    ],
  },
  // d*=5  branching=17.52  D=0.284  tiles=11
  {
    id: 'w17-l04',
    world: 17,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    wind: [
      { coord: { q: 0, r: 2 }, direction: 'W' },
    ],
    tiles: [
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2 },
    ],
  },
  // d*=6  branching=17.04  D=0.319  tiles=11
  {
    id: 'w17-l05',
    world: 17,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    wind: [
      { coord: { q: -2, r: 0 }, direction: 'NW' },
    ],
    tiles: [
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2 },
    ],
  },
  // d*=6  branching=14.84  D=0.361  tiles=11
  {
    id: 'w17-l06',
    world: 17,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    wind: [
      { coord: { q: 3, r: 0 }, direction: 'W' },
    ],
    tiles: [
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: 0, r: -3 }, color: 2 },
    ],
  },
  // d*=7  branching=15.71  D=0.417  tiles=11
  {
    id: 'w17-l07',
    world: 17,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    wind: [
      { coord: { q: -1, r: -2 }, direction: 'SW' },
    ],
    tiles: [
    { coord: { q: 2, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 2 },
    ],
  },
  // d*=7  branching=18.81  D=0.418  tiles=11
  {
    id: 'w17-l08',
    world: 17,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    wind: [
      { coord: { q: 2, r: -1 }, direction: 'SW' },
    ],
    tiles: [
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 2 },
    ],
  },
  // d*=8  branching=18.84  D=0.530  tiles=11
  {
    id: 'w17-l09',
    world: 17,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    wind: [
      { coord: { q: 0, r: 0 }, direction: 'NE' },
    ],
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 2 },
    { coord: { q: 1, r: 2 }, color: 2 },
    ],
  },
  // d*=8  branching=21.29  D=0.554  tiles=11
  {
    id: 'w17-l10',
    world: 17,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    wind: [
      { coord: { q: 0, r: 3 }, direction: 'NW' },
    ],
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 2 },
    ],
  },
];
